import { Routes } from '@angular/router';
import { ResetPasswordComponent } from '../shared/auth/reset-password/reset-password.component';
import { ForgotPasswordComponent } from '../shared/auth/forgot-password/forgot-password.component';
import { LogoutComponent } from '../shared/auth/login/logout.component';
import { LoginComponent } from '../shared/auth/login/login.component';
import { KnMainComponent } from './layout/kn-main.component';
import { KnProfileComponent } from './profile/kn-profile.component';
import { kitchenDashboardRoutes } from './dashboard/kitchen-dashboard.route';
import { reportBuilderRoutes } from './report-builder/report-builder.route';
import { PageNotFoundComponent } from '../shared/components/page-not-found/page-not-found.component';
import { AuthGuard } from '../shared/auth/guards/auth-guard.service';
import { RolePermission } from '../shared/auth/rbac/role-permission';
import { RolePermissionGuard } from '../shared/auth/guards/role-permission-guard.service';


export const kitchenRoutes: Routes = [
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'logout',
    component: LogoutComponent
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent
  },
  {
    path: '',
    component: KnMainComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        children: kitchenDashboardRoutes
      },
      {
        path: 'reports',
        children: reportBuilderRoutes
      },
      {
        path: 'profile',
        component: KnProfileComponent
      },
      {
        path: 'troubleshooting',
        loadChildren: 'app/kitchen/troubleshooting/troubleshooting.module#TroubleshootingModule'
      },
      {
        path: 'optimizations',
        loadChildren: 'app/kitchen/optimizations/optimizations.module#OptimizationsModule'
      },
      {
        path: 'discrepancies',
        loadChildren: 'app/kitchen/discrepancies/kn-discrepancies.module#KnDiscrepanciesModule'
      },
      {
        path: 'unit-requests',
        loadChildren: 'app/kitchen/unit-requests/kn-unit-requests.module#KnUnitRequestsModule'
      },
      {
        path: 'ads-txt',
        loadChildren: 'app/kitchen/ads-txt/kn-ads-txt.module#KnAdsTxtModule'
      },
      {
        path: 'ads-txt/:type',
        loadChildren: 'app/kitchen/ads-txt/kn-ads-txt.module#KnAdsTxtModule'
      },
      {
        path: 'widgets',
        loadChildren: 'app/kitchen/widgets/kn-widgets.module#KnWidgetsModule'
      },
      {
        path: 'content',
        loadChildren: 'app/kitchen/content/kn-content.module#KnContentModule'
      },
      {
        path: 'demand-partners',
        loadChildren: 'app/kitchen/demand-partners/kn-demand-partners.module#KnDemandPartners'
      },
      {
        path: 'blocks',
        loadChildren: 'app/kitchen/blocklist/kn-blocklist.module#KnBlocklistModule'
      },
      {
        path: 'ad-units',
        loadChildren: 'app/kitchen/ad-units/kn-ad-units.module#KnAdUnitsModule'
      },
      {
        path: 'support',
        loadChildren: 'app/shared/modules/support/support.module#SupportModule'
      },
      {
        path: 'onboarding-management',
        loadChildren: 'app/kitchen/onboarding-management/onboarding-management.module#OnboardingManagementModule'
      },
      {
        path: 'users',
        data: {
          permissions: [RolePermission.USERS_MODULE],
        },
        canActivate: [RolePermissionGuard],
        canLoad: [RolePermissionGuard],
        loadChildren: 'app/kitchen/users/users.module#UsersModule'
      },
      {
        path: 'publishers',
        data: {
          permissions: [RolePermission.PUBLISHERS_MODULE],
        },
        canActivate: [RolePermissionGuard],
        canLoad: [RolePermissionGuard],
        loadChildren: 'app/kitchen/publishers/publishers.module#PublishersModule'
      },
      {
        path: 'site-approval',
        data: {
          permissions: [RolePermission.SITE_APPROVAL_MODULE],
        },
        canActivate: [RolePermissionGuard],
        canLoad: [RolePermissionGuard],
        loadChildren: 'app/kitchen/site-approval/kn-site-approval.module#KnSiteApprovalModule'
      },
      {
        path: 'app-approval',
        data: {
          permissions: [RolePermission.SITE_APPROVAL_MODULE],
        },
        canActivate: [RolePermissionGuard],
        canLoad: [RolePermissionGuard],
        loadChildren: 'app/kitchen/site-approval/kn-site-approval.module#KnSiteApprovalModule'
      },
    ],
  },
  {
    path: '**',
    component: PageNotFoundComponent,
  }
];
